import { render } from "./edit-client-pf.vue?vue&type=template&id=2e11eae9"
import script from "./edit-client-pf.vue?vue&type=script&lang=js"
export * from "./edit-client-pf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__